<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="addExplanation()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'name_or_id' | transloco"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="freeFilterLen"
                            (onKeyUpChange)="setFreeFilter($event)"
                        />
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Konsumenten</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setConsumerFilter($event)"
                            >
                                @for (consumer of consumers$ | async; track consumer) {
                                <mat-option [value]="consumer.id">{{consumer.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <mat-form-field>
                            <mat-label>Fächer</mat-label>
                            <mat-select
                                multiple
                                (valueChange)="setSubjectFilter($event)"
                            >
                                @for (subject of subjects$ | async; track subject) {
                                <mat-option [value]="subject.treeId">{{subject.name}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <div class="filter-item">
                        <pixl-state-cb
                            (onStateChange)="setStatusFilter($event)"
                            [withEmptyOption]="true"
                        />
                    </div>
                </div>
                <div class="main-toolbar-spacer-right"></div>
            </div>
            <div class="table-header-overlay"></div>
        </div>
    </div>

    <div class="table-container mat-elevation-z4">
        @if (explanations$ | async; as explanations) {
        <table
            mat-table
            [dataSource]="explanations"
            matSort
            (matSortChange)="announceSortChange($event)"
        >
            <ng-container matColumnDef="edit-actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="editExplanation(explanation)"
                        matTooltip="{{ 'edit_meta_data_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        [class.btn-warning]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="editContentExplanation(explanation)"
                        matTooltip="{{ 'edit_content_hint' | transloco }}"
                    >
                        <mat-icon>draw</mat-icon>
                    </button>
                    <button
                        [class.btn-info]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="copyExplanation(explanation)"
                        matTooltip="{{ 'copy_record_hint' | transloco }}"
                    >
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Delete"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                        (click)="deleteExplanation(explanation)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button
                        [class.btn-primary]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Delete"
                        matTooltip="{{ 'player_preview' | transloco }}"
                        (click)="previewPlayer2(explanation)"
                    >
                        <mat-icon>visibility</mat-icon>
                    </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ explanation.id }}</td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "name" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ explanation.name }}</td>
            </ng-container>

            <ng-container matColumnDef="consumer">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "application" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let exam"
                >
                    @if (exam.consumers) {
                    {{ getConsumer(exam.consumers.id, true) }}
                    } @else {
                    ---
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="competency">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "subject" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let exam"
                >
                    @if (exam.subjects) {
                    {{ getSubject(exam.subjects.id, true) }}
                    } @else {
                    ---
                    }
                </td>
            </ng-container>

            <ng-container matColumnDef="pages">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "pages" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ getPages(explanation.pages) }}</td>
            </ng-container>

            <ng-container matColumnDef="updated">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "created" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >{{ getCreatedDate(explanation.id) | date }}</td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                >{{ "state" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let explanation"
                >
                    <pixl-state-badge
                        [entity]="explanation"
                        [entityService]="explanationService"
                        [entityClass]="explanationStateClass"
                        [refresh$]="refresh$"
                        (badgeClicked)="currentSelectedRow.set($event)"
                    />
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        } @else {
        <pixl-table-loading-spinner [name]="'Erkläreinheiten'" />
        }
        <mat-paginator
            [pageIndex]="pageChange().pageIndex"
            [pageSize]="pageChange().pageSize"
            [pageSizeOptions]="[25, 50, 100]"
            [length]="totalItems">
        </mat-paginator>
    </div>
</div>